/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserCouncilRouteQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetUserCouncilRouteQuery = { __typename?: 'Query', user?: { __typename?: 'User', isCouncilStaffOf?: Array<{ __typename?: 'Council', id: string, name: string }> | null } | null };


export const GetUserCouncilRouteDocument = gql`
    query GetUserCouncilRoute($id: ID!) {
  user(id: $id) {
    isCouncilStaffOf {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserCouncilRouteQuery__
 *
 * To run a query within a React component, call `useGetUserCouncilRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCouncilRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCouncilRouteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCouncilRouteQuery(baseOptions: Apollo.QueryHookOptions<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables> & ({ variables: GetUserCouncilRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables>(GetUserCouncilRouteDocument, options);
      }
export function useGetUserCouncilRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables>(GetUserCouncilRouteDocument, options);
        }
export function useGetUserCouncilRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables>(GetUserCouncilRouteDocument, options);
        }
export type GetUserCouncilRouteQueryHookResult = ReturnType<typeof useGetUserCouncilRouteQuery>;
export type GetUserCouncilRouteLazyQueryHookResult = ReturnType<typeof useGetUserCouncilRouteLazyQuery>;
export type GetUserCouncilRouteSuspenseQueryHookResult = ReturnType<typeof useGetUserCouncilRouteSuspenseQuery>;
export type GetUserCouncilRouteQueryResult = Apollo.QueryResult<GetUserCouncilRouteQuery, GetUserCouncilRouteQueryVariables>;